import { render, staticRenderFns } from "./CancelSubscriptions.vue?vue&type=template&id=621bef7a&"
import script from "./CancelSubscriptions.vue?vue&type=script&lang=js&"
export * from "./CancelSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports